export const project = 'trade-directory';
export const isProd = process.env.NODE_ENV === 'production';
export const isDev = !isProd;
export const appVersion = process.env.VUE_APP_VERSION;
const env = process.env || {};
export const apiBase = env.VUE_APP_API_BASE;
export const apiNamespace = env.VUE_APP_API_NAMESPACE;
export const baseUrl = `${apiBase || ''}${apiNamespace || ''}`;
export const useCookies = env.VUE_APP_USE_COOKIES === 'true';
export const frontendBase = env.VUE_APP_FRONTEND || env.VUE_APP_API_BASE;

export const email = (isDev && (env.VUE_APP_ADMIN_USER as string)) || undefined;
export const password =
  (isDev && (env.VUE_APP_ADMIN_PASS as string)) || undefined;
